import { createSelector } from 'reselect';
import { getFileInfoById } from './getFileInfoById';
export const getEdsCreateRequestById = createSelector([getFileInfoById], fileInfo => {
    if (!fileInfo) {
        return null;
    }
    const edsCreateRequest = {
        caller: fileInfo.applicationName,
        applicationName: fileInfo.applicationName,
        correlationId: fileInfo.id,
        companyCode: fileInfo.companyCode,
        documentName: fileInfo.fileName,
        documentSizeInBytes: fileInfo.fileSizeInBytes
    };
    return edsCreateRequest;
});
//# sourceMappingURL=getEdsCreateRequestById.js.map